/**
 * LSC cart helpers.
 *
 * <lsc-cart-upsell>: adds the add-on row's product with Shopify's standard `updateCart` action, which Horizon
 * points at the cart drawer, so the cart re-renders in place. Without the actions the plain product form posts.
 *
 * <lsc-cart-quote>: publishes `lsc:quote_from_cart` when the buyer follows the quote link.
 */
class LscCartUpsell extends HTMLElement {
  connectedCallback() {
    this.addEventListener('submit', this.#handleSubmit);
  }

  disconnectedCallback() {
    this.removeEventListener('submit', this.#handleSubmit);
  }

  /** @param {SubmitEvent} event */
  #handleSubmit = async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-lsc-cart-add')) return;
    const actions = /** @type {any} */ (window).Shopify?.actions;
    const variantId = /** @type {HTMLInputElement | null} */ (form.querySelector('input[name="id"]'))?.value;
    if (!actions?.updateCart || !variantId) return;

    event.preventDefault();
    const button = form.querySelector('button');
    button?.setAttribute('aria-busy', 'true');
    try {
      const result = await actions.updateCart(
        { lines: [{ merchandiseId: `gid://shopify/ProductVariant/${variantId}`, quantity: 1 }] },
        { event: { context: 'cart' } }
      );
      if (result?.userErrors?.length) form.submit();
      else if (!document.querySelector('theme-drawer#cart-drawer')) window.location.reload();
    } catch (error) {
      console.warn('[lsc-cart] Could not add the add-on:', error);
      form.submit();
    } finally {
      button?.removeAttribute('aria-busy');
    }
  };
}

class LscCartQuote extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#handleClick);
  }

  /** @param {MouseEvent} event */
  #handleClick = (event) => {
    if (!(event.target instanceof Element) || !event.target.closest('a')) return;
    /** @type {any} */ (window).Shopify?.analytics?.publish?.('lsc:quote_from_cart', {
      locks: Number(this.dataset.locks || 0),
    });
  };
}

if (!customElements.get('lsc-cart-upsell')) customElements.define('lsc-cart-upsell', LscCartUpsell);
if (!customElements.get('lsc-cart-quote')) customElements.define('lsc-cart-quote', LscCartQuote);
